import DataSource from 'devextreme/data/data_source'
import _productService from 'services/products-services'
import { atomFamily } from 'recoil'
import { loadFn } from 'helpers/custom-data-source'



const ChangeRequestSource = (VersionSubscriptionId: any) =>


new DataSource({
    key: 'id',
    load: loadFn(_productService.getChangeRequests, { VersionSubscriptionId }),
})



export const changeRequestSourceAtom = atomFamily({
key: 'ChangeRequestSource',
default: (VersionSubscriptionId: any) => ChangeRequestSource(VersionSubscriptionId),
dangerouslyAllowMutability:true
})